module.exports = __webpack_public_path__ + "static/media/default.5460d49f.png";